import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { BrandIconUtil } from '../../../utils/brand.util';
import { APP_PROPS } from '../../../cai-common.module';
import { ApplicationProperties } from '../../../core/_base/layout/models/app-properties.model';

@Component({
  selector: 'kt-congratulation',
  templateUrl: './congratulation.component.html',
  styleUrls: ['./congratulation.component.scss'],
  standalone: false,
})
export class CongratulationComponent implements OnInit {
  @Output() onNext: EventEmitter<void> = new EventEmitter();

  constructor(
    @Inject(APP_PROPS)
    private readonly appProperties: ApplicationProperties,
  ) {}

  ngOnInit() {}

  get backgroundImage(): string {
    return BrandIconUtil.fetchBackgroundIcon(
      this.appProperties.logo,
      '/assets/media/logos/',
    );
  }
  get isCargoWallet(): boolean {
    return this.appProperties.name === 'cargowallet';
  }
}
